import API from "@/api";
import { showGlobalLoading } from "@/components/globalLoading";
import { has } from "lodash";
import { useEffect, useState } from "react";

export function useFinanceOrderList(outParams: {}, childRef: any) {
	const { showLoading, hideLoading } = showGlobalLoading();
	const [data, setData] = useState<any[]>([]);
	const [hasMore, setHasMore] = useState(true);
	const [page, setPage] = useState(0);
	const [targetData, setTargetData] = useState<Record<string, any>>({});
	const pageSize = 40;
	const postFinanceOrderListHandle = async (isRefresh = false) => {
		try {
			let pageNum = isRefresh ? 0 : page;
			const params: any = {
				page: pageNum,
				pageSize: pageSize,
			};
			if (childRef && childRef.current) {
				params["startTime"] = childRef.current.startTime;
				params["endTime"] = childRef.current.endTime;
			}
			showLoading();
			Object.assign(params, outParams);
			const result: any = await API.finances.apiFinanceOrderList(params);
			if (result?.code === 0) {
				const contentData = result.content.data;
				const haveMore = result.content.haveMore;
				if (has(result.content, "targetData")) {
					setTargetData(result.content.targetData);
				}
				setHasMore(haveMore);
				if (haveMore) {
					if (isRefresh) {
						setPage(1);
					} else {
						setPage((prevPage) => prevPage + 1);
					}
				}
				if (pageNum === 0) {
					setData(contentData);
				} else {
					setData((prevData) => [...prevData, ...contentData]);
				}
			}
		} catch (error) {
			console.log("---postFinanceOrderList--:", error);
		} finally {
			hideLoading();
		}
	};
	const handleRefresh = async () => {
		// 模拟刷新数据
		await postFinanceOrderListHandle(true);
	};

	const handleFetchMore = async () => {
		// 模拟加载更多数据
		await postFinanceOrderListHandle();
	};

	useEffect(() => {
		postFinanceOrderListHandle();
	}, []);

	return { data, targetData, hasMore, handleRefresh, handleFetchMore };
}

export function useAgentHomeMember(outParams: {}) {
	const { showLoading, hideLoading } = showGlobalLoading();
	const [agentList, setAgentList] = useState<Record<string, any>>({});
	const [membersData, setmembersData] = useState<any[]>([{}]);
	const [hasMore, setHasMore] = useState(true);
	const [page, setPage] = useState(0);

	const pageSize = 40;
	const postFinanceAgentHomeMemberHandle = async (isRefresh = false) => {
		try {
			let pageNum = isRefresh ? 0 : page;
			const params: any = {
				page: pageNum,
				pageSize: pageSize,
			};
			Object.assign(params, outParams);
			const result: any = await API.finances.apiFinanceAgentHomeMember(
				params
			);
			if (result?.code === 0) {
				const contentData = result.content.data;
				const haveMore = contentData.memberHaveMore;
				setHasMore(haveMore);
				if (haveMore) {
					if (isRefresh) {
						setPage(1);
					} else {
						setPage((prevPage) => prevPage + 1);
					}
				}
				if (pageNum === 0) {
					setmembersData(contentData.members);
					setAgentList(contentData.agent);
				} else {
					// 第二页数据未知
					setmembersData((prevData) => [
						...prevData,
						...contentData.members,
					]);
				}
			}
		} catch (error) {
			console.log("---apiFinanceAgentHomeMember--:", error);
		}
	};
	const handleRefresh = async () => {
		// 模拟刷新数据
		await postFinanceAgentHomeMemberHandle(true);
	};

	const handleFetchMore = async () => {
		// 模拟加载更多数据
		await postFinanceAgentHomeMemberHandle();
	};

	const initPage = async () => {
		showLoading();
		await postFinanceAgentHomeMemberHandle(true);
		hideLoading();
	};

	useEffect(() => {
		// initPage();
	}, []);

	return { agentList, membersData, hasMore, handleRefresh, handleFetchMore };
}

export function useFinanceOrderRecords(outParams: {}, childRef: any) {
	const { showLoading, hideLoading } = showGlobalLoading();
	const [data, setData] = useState<any[]>([]);
	const [targetData, setTargetData] = useState<Record<string, any>>({});
	const [hasMore, setHasMore] = useState(true);
	const [page, setPage] = useState(0);
	const pageSize = 20;

	const postFinanceOrderRecordsHandle = async (isRefresh = false) => {
		try {
			let pageNum = isRefresh ? 0 : page;
			const params: any = {
				page: pageNum,
				pageSize: pageSize,
			};
			if (childRef.current) {
				params["startTime"] = childRef.current.startTime;
				params["endTime"] = childRef.current.endTime;
			}
			Object.assign(params, outParams);
			showLoading();
			const result: any = await API.finances.apiFinanceOrderRecords(
				params
			);
			if (result?.code === 0) {
				const contentData = result.content.data;
				const haveMore = result.content.haveMore;
				if (has(result.content, "targetData")) {
					setTargetData(result.content.targetData);
				}
				setHasMore(haveMore);
				if (haveMore) {
					if (isRefresh) {
						setPage(1);
					} else {
						setPage((prevPage) => prevPage + 1);
					}
				}
				if (pageNum === 0) {
					setData(contentData);
				} else {
					setData((prevData) => [...prevData, ...contentData]);
				}
			}
		} catch (error) {
			console.log("---apiFinanceOrderRecords--:", error);
		} finally {
			hideLoading();
		}
	};
	const handleRefresh = async () => {
		// 模拟刷新数据
		await postFinanceOrderRecordsHandle(true);
	};

	const handleFetchMore = async () => {
		// 模拟加载更多数据
		await postFinanceOrderRecordsHandle();
	};

	useEffect(() => {
		postFinanceOrderRecordsHandle();
	}, []);

	return { data, hasMore, targetData, handleRefresh, handleFetchMore };
}

export function useAgentOtherMember(outParams: {}) {
	const { showLoading, hideLoading } = showGlobalLoading();
	const [membersData, setmembersData] = useState<any[]>([]);
	const [hasMore, setHasMore] = useState(true);
	const [page, setPage] = useState(0);

	const pageSize = 40;
	const postInviteRecordListHandle = async (isRefresh = false) => {
		try {
			let pageNum = isRefresh ? 0 : page;
			const params: any = {
				page: pageNum,
				pageSize: pageSize,
			};
			Object.assign(params, outParams);
			if (isRefresh) showLoading();
			const result: any = await API.members.postInviteRecordList(params);
			if (result?.code === 0) {
				const contentData = result.content.data;
				const haveMore = result.content.haveMore;
				setHasMore(haveMore);
				if (haveMore) {
					if (isRefresh) {
						setPage(1);
					} else {
						setPage((prevPage) => prevPage + 1);
					}
				}
				if (pageNum === 0) {
					setmembersData(contentData);
				} else {
					// 第二页数据未知
					setmembersData((prevData) => [...prevData, ...contentData]);
				}
			}
		} catch (error) {
			console.log("---postInviteRecordListHandle--:", error);
		} finally {
			hideLoading();
		}
	};
	const handleRefresh = async () => {
		// 模拟刷新数据
		await postInviteRecordListHandle(true);
	};

	const handleFetchMore = async () => {
		// 模拟加载更多数据
		await postInviteRecordListHandle();
	};

	const initPage = async () => {
		await postInviteRecordListHandle(true);
	};

	useEffect(() => {
		initPage();
	}, []);

	return { membersData, hasMore, handleRefresh, handleFetchMore };
}
